import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router'
import cx from 'classnames'
import classes from '../List.scss'

import ListColumn from '../Column'

export const ListRow = (props) => {
  const options = Array.isArray(props.options) && props.options || props.options && [props.options] || []
  const link = props.link

  const classList = {
    [classes['item']]: classes['item'],
    [classes['item--link']]: !!link
  }

  // add all options into the classList
  options.forEach((option) => {
    classList[classes[`item--${option}`]] = classes[`item--${option}`]
  })

  const onClick = () => link && (!options.includes('disabled') || options.includes('alwaysLink'))
    ? props.router.push(link)
    : false

  return <tr className={cx(classList)} onClick={onClick}>
    {props.columns && props.columns.map((column, index) => {
      // child is either a string, node, or array of node or strings
      const options = props.columnOptions && props.columnOptions[index]

      return <ListColumn key={index} options={options}>
        {column && typeof column.filter === 'function' && column.filter(line => !!line).map((line, lineIndex) =>
          <span className={classes['column--row']} key={lineIndex}>{line}</span>
        ) || column}
      </ListColumn>
    })}
  </tr>
}

ListRow.propTypes = {
  columns: PropTypes.array.isRequired,
  link: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string
  ]),
  columnOptions: PropTypes.array,

  router: PropTypes.object.isRequired // required for rows to link
}

ListRow.defaultProps = {
  options: [],
  columnOptions: []
}

export default withRouter(ListRow)



// WEBPACK FOOTER //
// ./src/components/BetterList/Row/ListRow.js